import { OTP, OTP_SUCCESS, OTP_FAILURE } from "../Constants";

export const Otp = (payload) => ({
    type: OTP,
    payload
});

export const OtpSuccess = (payload) => ({
    type: OTP_SUCCESS,
    payload
});

export const OtpFailure = (payload) => ({
    type: OTP_FAILURE,
    payload
});